<template>
  <div>
    <div class="color-choice col-hspace">
      <button
        type="button"
        class="color-choice__item"
        v-for="(color, index) in colors"
        :class="active.name === color.name ? 'active': ''"
        :key="index"
        @click="changeColor(color)"
      >
        <span :class="color.name"></span>
        <p class="color-choice__title">{{ color.title }}</p>
      </button>
    </div>

    <div class="col-xs-12 col-big-vtspace">
      <p class="tcenter"><span class="bold">Couleur sélectionnée :</span> {{ active.title }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    colors: {
      type: Array,
      default: () => [],
    },
    active: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isDesktop: false,
    };
  },
  methods: {
    mobile() {
      this.isDesktop = window.matchMedia('(max-width: 768px)').matches;
    },
    changeColor(color) {
      this.$emit('change-color', color);
    },
    hovered(value, index) {
      this.$emit('hover-color', value, index);
    },
  },
  mounted() {
    this.mobile();
  },
};
</script>
